import { useEffect, useRef } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'umi';
import { useNewSelectorParams } from '../../utils/useNewSelectorParams';
import { FilterItemType } from '../../types/dashboard';
import { formatSortFiltersData } from '../../utils/_config/formatSortFiltersData';
import { getSelectorMap } from '../../_config/filterListMap';

export const useFilterData = (path:string, pageDefaultSelector?: FilterItemType[], isUseFrontFilterConfig?:boolean, extraFilterList?:string[],api?: string) => {
  const dispatch = useDispatch();
  const gameCode = useSelector(
    (state: any) => state.dashboard?.currentGame?.game_code,
    shallowEqual,
  );
  // 用 ref 存储快照，useEffect 仅 mount 时执行一次，切游戏时页面整体重新挂载
  const gameCodeRef = useRef(gameCode);
  gameCodeRef.current = gameCode;
  const  { loading, getSelectorList} = useNewSelectorParams({
    realPath: path,
    pageDefaultSelector: pageDefaultSelector || [],
    isUseFrontFilterConfig: isUseFrontFilterConfig || false,
    extraFilterList,
    api,
    visibleZeroReq: true
  });
  const selectorRef = useRef<any>({});

  // 和后端核对后地区数据源不一致需要重新调用selector接口拿数据
  useEffect(() => {
    getSelectorList().then((data)=>{
      const resultData = formatSortFiltersData(data || {});
      selectorRef.current = { ...(resultData || {}), gameCode: gameCodeRef.current };
      dispatch({
        type: 'dashboardSetting/save',
        payload: {
          selector: selectorRef.current,
          selectorMap: getSelectorMap(selectorRef.current),
        },
      });
    }).catch((e)=>{
      console.log(e);
    });
  }, []);

  return {
    loading,
    selector: selectorRef.current
  };
};